import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));

// ==============================|| AUTH ROUTING ||============================== //
// 사내 admin 도메인 — Google 로그인만. /register 는 /login 으로 redirect.

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/register',
      element: <Navigate to="/login" replace />
    }
  ]
};

export default LoginRoutes;
